import { Component } from 'react';
import { Image, Message, Table, List, Checkbox, Segment } from 'semantic-ui-react';
import logo from '../../assets/logo.png';

class ReportCapCall extends Component {

    displayError = (error, title, message) => {
        return (<Message negative><Message.Header>{title}</Message.Header>{message}</Message>);
    }

    getProjectTitle = () => {
        let title = '';
        this.props.projectState.project.title.forEach(item => {
            if (item.translation !== '') {
                title = item.translation + ' - ' + item.language;
            }
            if (item.language === 'EN' && item.translation !== '') {
                title = item.translation;
            }
        });
        return (title);
    }

    renderProjectDescription = () => {
        return (
            <Table celled>
                <Table.Body>
                    <Table.Row key="0-1">
                        <Table.Cell width="4">Project Number</Table.Cell>
                        <Table.Cell>{this.props.projectState.project.customIdentifier}</Table.Cell>
                    </Table.Row>
                    <Table.Row key="0-2">
                        <Table.Cell >Project Acronym</Table.Cell>
                        <Table.Cell>{this.props.projectState.project.acronym}</Table.Cell>
                    </Table.Row>
                    <Table.Row key="0-3">
                        <Table.Cell >Project Title</Table.Cell>
                        <Table.Cell>{this.getProjectTitle()}</Table.Cell>
                    </Table.Row>
                </Table.Body>
            </Table>
        );
    }

    getProgrammePriority = () => {
        const programmePriorityCode = this.props.projectState.project.programmePriority.code;
        let programmePriorityTranslation
        this.props.projectState.project.programmePriority.title.forEach(item => {
            if (item.language === 'EN') {
                programmePriorityTranslation = item.translation;
            }
        });
        return (programmePriorityCode + ' - ' + programmePriorityTranslation);
    }

    renderProjectPriority = () => {
        try {
            return (
                <Table celled>
                    <Table.Body>
                        <Table.Row key="1-1">
                            <Table.Cell width="4">Priority</Table.Cell>
                            <Table.Cell>{this.getProgrammePriority()}</Table.Cell>
                        </Table.Row>
                        <Table.Row key="1-2">
                            <Table.Cell>Specific Objective</Table.Cell>
                            <Table.Cell>{this.props.projectState.project.specificObjective.code} - {this.props.projectState.project.specificObjective.programmeObjectivePolicy}</Table.Cell>
                        </Table.Row>
                        <Table.Row key="1-3">
                            <Table.Cell>LP Name</Table.Cell>
                            <Table.Cell>{this.props.projectState.leadPartner.nameInEnglish}</Table.Cell>
                        </Table.Row>
                        <Table.Row key="1-4">
                            <Table.Cell>LP Country</Table.Cell>
                            <Table.Cell>{this.props.projectState.leadPartner.addresses[0].countryCode}</Table.Cell>
                        </Table.Row>
                        <Table.Row key="1-5">
                            <Table.Cell>Start date</Table.Cell>
                            <Table.Cell>{new Date(this.props.projectState.project.contract.projectStartDate).toLocaleDateString('fr-FR').replace(/\//g, '-')}</Table.Cell>
                        </Table.Row>
                        <Table.Row key="1-6">
                            <Table.Cell>Original project duration (in months)</Table.Cell>
                            <Table.Cell>{this.props.projectState.project.duration}</Table.Cell>
                        </Table.Row>
                        <Table.Row key="1-7">
                            <Table.Cell>Capitalisation initiative duration (in months)</Table.Cell>
                            <Table.Cell>{this.props.projectState.project.capCallDuration}</Table.Cell>
                        </Table.Row>
                    </Table.Body>
                </Table>);
        } catch (error) {
            return this.displayError(error, "Can't find data for Project Priority", 'Please Check JEMS APP data');
        }
    }

    renderProjectCosts = () => {
        try {
            return (
                <Table celled>
                    <Table.Header className='table-header'>
                            <Table.Row key="0" style={this.headerStyle}>
                                <Table.Cell></Table.Cell>
                                <Table.Cell>Original project budget</Table.Cell>
                                <Table.Cell>Capitalisation initiative budget</Table.Cell>
                                <Table.Cell>Revised Total budget</Table.Cell>
                            </Table.Row>
                        </Table.Header>
                    <Table.Body>
                        <Table.Row key="2-1">
                            <Table.Cell width="4">ERDF</Table.Cell>
                            {this.props.projectState.project.coFinancing ? <Table.Cell>{'€ ' + this.props.projectState.project.coFinancing.projectManagementCoFinancing.totalEuFundingAmount.toLocaleString('en')}</Table.Cell> : <Table.Cell>€ 0</Table.Cell>}
                            {this.props.projectState.project.capCallBudgetERDF ? <Table.Cell>{'€ ' + this.props.projectState.project.capCallBudgetERDF.toLocaleString('en')}</Table.Cell> : <Table.Cell>€ 0</Table.Cell>}
                            {this.props.projectState.project.coFinancing && this.props.projectState.project.capCallBudgetERDF ? <Table.Cell>{'€ ' + (this.props.projectState.project.coFinancing.projectManagementCoFinancing.totalEuFundingAmount + this.props.projectState.project.capCallBudgetERDF).toLocaleString('en')}</Table.Cell> : <Table.Cell>€ 0</Table.Cell>}
                        </Table.Row>
                        <Table.Row key="2-2">
                            <Table.Cell width="4">TEC</Table.Cell>
                            {this.props.projectState.project.coFinancing ? <Table.Cell>{'€ ' + this.props.projectState.project.coFinancing.projectManagementCoFinancing.totalFundAndContribution.toLocaleString('en')}</Table.Cell> : <Table.Cell>€ 0</Table.Cell>}
                            {this.props.projectState.project.capCallBudgetTEC ? <Table.Cell>{'€ ' + this.props.projectState.project.capCallBudgetTEC.toLocaleString('en')}</Table.Cell> : <Table.Cell>€ 0</Table.Cell>}
                            {this.props.projectState.project.coFinancing && this.props.projectState.project.capCallBudgetTEC ? <Table.Cell>{'€ ' + (this.props.projectState.project.coFinancing.projectManagementCoFinancing.totalFundAndContribution + this.props.projectState.project.capCallBudgetTEC).toLocaleString('en')}</Table.Cell> : <Table.Cell>€ 0</Table.Cell>}
                        </Table.Row>
                    </Table.Body>
                </Table>);
        } catch (error) {
            return this.displayError(error, "Can't find data for Project Costs", 'Please Check JEMS APP data');
        }
    }

    renderImplementationAndSpendingProfile = () => {
        try {
            return (
                <div>
                    <p>Project implementation stage: {(() => {
                        const start = new Date(this.props.projectState.project.contract.projectStartDate);
                        const end = new Date(2026, 5, 1);
                        const months = (end.getFullYear() - start.getFullYear()) * 12 + (end.getMonth() - start.getMonth()) + (end.getDate() >= start.getDate() ? 0 : -1);
                        const pct = (months / this.props.projectState.project.duration) * 100;
                        return `${pct.toFixed(1)}%`;
                    })()} completed (in view of current month of implementation)</p>
                    <p>Date of latest submitted progress report: {this.props.projectState.project.lastSubmittedProjectReport.firstSubmission ? new Date(this.props.projectState.project.lastSubmittedProjectReport.firstSubmission).toLocaleDateString('fr-FR').replace(/\//g, '-') : 'N/A'}</p>
                    <Table celled>
                        <Table.Header className='table-header'>
                            <Table.Row key="0" style={this.headerStyle}>
                                <Table.Cell></Table.Cell>
                                <Table.Cell>Project budget</Table.Cell>
                                <Table.Cell>Spent</Table.Cell>
                                <Table.Cell>Percent spending</Table.Cell>
                            </Table.Row>
                        </Table.Header>
                    <Table.Body>
                        <Table.Row key="2-1">
                            <Table.Cell width="4">ERDF</Table.Cell>
                            {this.props.projectState.project.coFinancing ? <Table.Cell>{'€ ' + this.props.projectState.project.coFinancing.projectManagementCoFinancing.totalEuFundingAmount.toLocaleString('en')}</Table.Cell> : <Table.Cell>€ 0</Table.Cell>}
                            <Table.Cell>{'€ ' + (this.props.projectState.project.financialOverview.funds[0].previouslyReported + this.props.projectState.project.financialOverview.funds[0].currentReport).toLocaleString('en')}</Table.Cell>
                            <Table.Cell>{
                                ((this.props.projectState.project.financialOverview.funds[0].previouslyReported + this.props.projectState.project.financialOverview.funds[0].currentReport) / this.props.projectState.project.coFinancing.projectManagementCoFinancing.totalEuFundingAmount * 100).toFixed(2) + ' %'
                            }</Table.Cell>
                        </Table.Row>
                        <Table.Row key="2-2">
                            <Table.Cell width="4">TEC</Table.Cell>
                            {this.props.projectState.project.coFinancing ? <Table.Cell>{'€ ' + this.props.projectState.project.coFinancing.projectManagementCoFinancing.totalFundAndContribution.toLocaleString('en')}</Table.Cell> : <Table.Cell>€ 0</Table.Cell>}
                            <Table.Cell>{'€ ' + (this.props.projectState.project.financialOverview.total.previouslyReported + this.props.projectState.project.financialOverview.total.currentReport).toLocaleString('en')}</Table.Cell>
                            <Table.Cell>{
                                ((this.props.projectState.project.financialOverview.total.previouslyReported + this.props.projectState.project.financialOverview.total.currentReport) / this.props.projectState.project.coFinancing.projectManagementCoFinancing.totalFundAndContribution * 100).toFixed(2) + ' %'
                            }</Table.Cell>
                        </Table.Row>
                    </Table.Body>
                    </Table> 
                </div>
            );
        } catch (error) {
            return this.displayError(error, "Can't find data for Implementation and Spending profile", 'Please Check JEMS APP data');
        }
    }

    getCheckListById = (id) => {
        let checkList = {};
        const checkLists = this.props.projectState.projectChecklists;
        checkLists.forEach(item => {
            if (item.id === id) {
                checkList = item;
            };
        });
        return checkList;
    }

    getChecklistByName = (name) => {
        console.warn("getChecklistByName");
        console.warn(name);
        let checklist = undefined;
        let checklists = this.props.projectState.projectChecklists.toSorted((a, b) => b.id - a.id);
        try {
            for (let i = 0; i < checklists.length; i++) {
                if (checklists[i].name === name) {
                    checklist = checklists[i];
                    return checklist;
                }
            }
        } catch (error) {
            return undefined
        }
    }

    renderProjectSummary = () => {
        try {
            const projectSummaryName = this.props.projectState.capCallSummaryCheckList;
            const projectSummary = this.getChecklistByName(projectSummaryName);
            let summaryComponents = projectSummary.detail.components;
            let sortedSummaryComponents = summaryComponents.slice().sort((a, b) => a.position - b.position);
            return (
                <List>
                    {sortedSummaryComponents.map(item => {
                        if (item.type !== 'HEADLINE') {
                            return (
                                <List.Item className='line-break'>{item.instanceMetadata ? item.instanceMetadata.explanation : undefined}</List.Item>
                            );
                        } else {
                            return undefined;
                        }
                    })}
                </List>
            );
        } catch (error) {
            return this.displayError(error, "Can't find data for Summary checklist of project", 'Please Check JEMS APP data');
        }
    }

    renderEligibilityChecklist = () => {
        try {
            const eligibilityChecklistName = this.props.projectState.capCallEligibility;
            const eligibilityChecklist = this.getChecklistByName(eligibilityChecklistName);
            let eligibilityComponents = eligibilityChecklist.detail.components;
            let sortedComponents = eligibilityComponents.slice().sort((a, b) => a.position - b.position);
            return (
                <div>
                    <Table celled>
                        <Table.Header className='table-header'>
                            <Table.Row key="0" style={this.headerStyle}>
                                <Table.Cell>Criteria</Table.Cell>
                                <Table.Cell>Y/N</Table.Cell>
                            </Table.Row>
                        </Table.Header>
                        <Table.Body>
                            {sortedComponents.map(item => {
                                if (item.instanceMetadata) {
                                    return (
                                        <Table.Row key={item.id}>
                                            <Table.Cell>{item.programmeMetadata.question} {item.instanceMetadata.justification ? <Message className='line-break' content={item.instanceMetadata.justification} /> : undefined}</Table.Cell>
                                            <Table.Cell>{item.instanceMetadata.answer}</Table.Cell>
                                        </Table.Row>
                                    );
                                } else {
                                    return (
                                        <Table.Row key={item.id}>
                                            <Table.Cell>{item.programmeMetadata.question}<Message warning>There is no data for this Criteria</Message></Table.Cell>
                                            <Table.Cell></Table.Cell>
                                        </Table.Row>
                                    );
                                }
                            })}
                        </Table.Body>
                    </Table>
                </div>
            );
        } catch (error) {
            return this.displayError(error, "Can't find data for Eligibility checklist", 'Please Check JEMS APP data');
        }
    }


    getQualityAssessmentSummary = () => {
        const qualityChecklistName = this.props.projectState.capCallQuality;
        const qualityChecklist = this.getChecklistByName(qualityChecklistName);
        console.warn("qualityChecklist");
        console.warn(qualityChecklist);
        let qualityComponents = qualityChecklist.detail.components;
        let sortedComponents = qualityComponents.slice().sort((a, b) => a.position - b.position);
        return sortedComponents;
    }

    getQualityAssessmentScore = () => {
        const qualityAssessmentSummary = this.getQualityAssessmentSummary().filter(item => item.type === 'SCORE');
        return qualityAssessmentSummary.filter(item => item.type === 'SCORE');   
    }

    renderQualityAssessmentOverallScore = () => {
        let qualityAssessmentScores = [];
        const qualityAssessmentSummary = this.getQualityAssessmentSummary().filter(item => item.type === 'SCORE');
        for (let item of qualityAssessmentSummary) {
            let score = {
                score: item.instanceMetadata.score,
                weight: item.programmeMetadata.weight,
                weightedScore: Number(item.programmeMetadata.weight) * Number(item.instanceMetadata.score)
            };
            qualityAssessmentScores.push(score);
        }
        return (
            <div className='overall-score'>Overall Score {qualityAssessmentScores.reduce((accumulator, a) => accumulator + a.weightedScore, 0).toFixed(2)}/5 (100%)</div>
        );
    }

    renderQualityAssessment = () => {
        try {
            const qualityAssessmentSummary = this.getQualityAssessmentSummary();
            const qualityAssessmentScore = this.getQualityAssessmentScore();
            console.warn(qualityAssessmentScore);
            return (  
                <div>
                    <Table celled>
                        <Table.Header >
                            <Table.Row key="0" className='table-header'>
                                <Table.Cell>Quality Assessment Summary</Table.Cell>
                                <Table.Cell textAlign='center'>Score (1-5)</Table.Cell>
                                <Table.Cell textAlign='center'>Weight</Table.Cell>
                            </Table.Row>
                        </Table.Header>
                        <Table.Body>
                            {qualityAssessmentScore.map(item => {
                                return (
                                    <Table.Row key={item.id}>
                                        <Table.Cell>{item.programmeMetadata.question}</Table.Cell>
                                        <Table.Cell textAlign='center'>{item.instanceMetadata.score}</Table.Cell>
                                        <Table.Cell textAlign='center'>{item.programmeMetadata.weight * 100}%</Table.Cell>
                                    </Table.Row>
                                )
                            })}
                        </Table.Body>
                        <Table.Footer>
                            <Table.Row className='table-footer'>
                                <Table.Cell textAlign='right'>Total</Table.Cell>
                                <Table.Cell textAlign='center'>{qualityAssessmentScore.reduce((accumulator, a) => accumulator + Number(a.programmeMetadata.weight) * Number(a.instanceMetadata.score) , 0).toFixed(2)}</Table.Cell>
                                <Table.Cell textAlign='right'></Table.Cell>
                            </Table.Row>
                        </Table.Footer>
                    </Table>
                    {qualityAssessmentSummary.map(item => {
                        switch (item.instanceMetadata.type) {
                            case 'OPTIONS_TOGGLE':
                                return (
                                    <Table>
                                        <Table.Body>
                                            <Table.Row key={item.id}>
                                                <Table.Cell>{item.programmeMetadata.question} {item.instanceMetadata.justification ? <Message className='line-break' content={item.instanceMetadata.justification} /> : undefined}</Table.Cell>
                                                <Table.Cell>{item.instanceMetadata.answer}</Table.Cell>
                                            </Table.Row>
                                        </Table.Body>
                                    </Table>
                                )
                            case 'TEXT_INPUT':
                                return (
                                    <div className="criterion" width='100%'>
                                        <p className="criterion-title">{item.programmeMetadata.question}</p>
                                        <Message content={item.instanceMetadata.explanation} className='line-break' />
                                    </div>
                                )
                            case 'SCORE':
                                return (
                                    <Table celled>
                                        <Table.Body>
                                            <Table.Row key={item.id}>
                                                <Table.Cell>{item.programmeMetadata.question}</Table.Cell>
                                                <Table.Cell>Score({Number(item.programmeMetadata.weight) * 100}%)</Table.Cell>
                                                <Table.Cell>{item.instanceMetadata.score}/5</Table.Cell>
                                            </Table.Row>
                                            <Table.Row>
                                                <Table.Cell colSpan='3'>{item.instanceMetadata.justification ? <Message className='line-break' content={item.instanceMetadata.justification} /> : undefined}</Table.Cell>
                                            </Table.Row>
                                        </Table.Body>
                                    </Table>
                                )
                            default:
                                return (
                                    <div className="criterion" width='100%'>
                                        <p className="criterion-title">{item.programmeMetadata.value}</p>
                                    </div>
                                )
                        }
                    })}
                </div>
            );
        } catch (error) {
            return this.displayError(error, "Can't find data for Quality Checklist", 'Please Check JEMS APP data');
        }
    }

    getJsOpinion = () => {
        const jsOpinionChecklistName = this.props.projectState.capCallJSOpinion;
        const jsOpinionChecklist = this.getChecklistByName(jsOpinionChecklistName);
        let jsOpinionComponents = jsOpinionChecklist.detail.components;
        let sortedComponents = jsOpinionComponents.slice().sort((a, b) => a.position - b.position);
        // console.error(sortedComponents);
        let jsOpinion = {};
        jsOpinion.details = [];
        jsOpinion.summary = sortedComponents[1].instanceMetadata.explanation;
        jsOpinion.opinion = sortedComponents[2].instanceMetadata.answer;
        jsOpinion.opinionDetail = sortedComponents[2].instanceMetadata.justification;

        for (let i = 3; i < sortedComponents.length; i++) {
            
            if (sortedComponents[i].type === 'TEXT_INPUT') {
                let detail = {};
                detail.question = sortedComponents[i].programmeMetadata.question;
                detail.explanation = sortedComponents[i].instanceMetadata.explanation;
                jsOpinion.details.push(detail);
            }
        }
        
        return jsOpinion;
    }

    renderJSOpinion = () => {
        try {
            const jsOpinion = this.getJsOpinion();
            return (
                <div className='full-width line-break'>
                    {jsOpinion.summary}
                    <div>
                        <h3 className='little-margin'>{jsOpinion.opinion}</h3>
                        {jsOpinion.opinionDetail ? <p>{jsOpinion.opinionDetail}</p> : undefined}
                        {jsOpinion.details.map(item => {
                            return (
                                item.explanation ?
                                    <div className='prevent-page-break full-width'>
                                        <p className="criterion-title little-margin" style={{ marginTop: '20px' }}>{item.question}</p><Message fluid content={item.explanation} className='line-break' style={{ width: '100%', boxSizing: 'border-box' }} />
                                    </div>
                                    : undefined
                            )
                        })}
                    </div>
                </div>
            )
        } catch (error) {
            return this.displayError(error, "Can't find data for JS Opinion Checklist", 'Please Check JEMS APP data');
        }
    }

    getPartnerName = (partnerIndex, capCall = false) => {
        if (capCall) {
            return this.props.projectState.capCallPartners[partnerIndex].identity.nameInEnglish;
        }
        else {
            return this.props.projectState.partners.find(partner => partner.sortNumber === partnerIndex).detail.nameInEnglish;
        }
    }

    renderGberProposal = (proposalGber, question) => {
        switch (proposalGber) {
            case 'Article 20':
                return (
                    <Table celled>
                        <Table.Body>
                            <Table.Row key="0">
                                <Table.Cell>{question}</Table.Cell>
                                <Table.Cell width={2}><Checkbox label='Article 20' readOnly defaultChecked /></Table.Cell>
                                <Table.Cell width={2}><Checkbox label='Article 20a' readOnly /></Table.Cell>
                                <Table.Cell width={2}><Checkbox label='NA' readOnly /></Table.Cell>
                            </Table.Row>
                        </Table.Body>
                    </Table>
                );
            case 'Article 20a':
                return (
                    <Table celled>
                        <Table.Body>
                            <Table.Row key="0">
                                <Table.Cell>{question}</Table.Cell>
                                <Table.Cell width={2}><Checkbox label='Article 20' readOnly /></Table.Cell>
                                <Table.Cell width={2}><Checkbox label='Article 20a' readOnly defaultChecked /></Table.Cell>
                                <Table.Cell width={2}><Checkbox label='NA' readOnly /></Table.Cell>
                            </Table.Row>
                        </Table.Body>
                    </Table>
                );
            default:
                return (
                    <Table celled>
                        <Table.Body>
                            <Table.Row key="0">
                                <Table.Cell>{question}</Table.Cell>
                                <Table.Cell width={2}><Checkbox label='Article 20' readOnly /></Table.Cell>
                                <Table.Cell width={2}><Checkbox label='Article 20a' readOnly /></Table.Cell>
                                <Table.Cell width={2}><Checkbox label='NA' readOnly defaultChecked /></Table.Cell>
                            </Table.Row>
                        </Table.Body>
                    </Table>
                );
        }
    }
    renderProposal = (proposal, question) => {
        switch (proposal) {
            case 'De minimis':
                return (
                    <Table celled>
                        <Table.Body>
                            <Table.Row key="0">
                                <Table.Cell>{question}</Table.Cell>
                                <Table.Cell width={2}><Checkbox label='De minimis' readOnly defaultChecked /></Table.Cell>
                                <Table.Cell width={2}><Checkbox label='Other' readOnly /></Table.Cell>
                                <Table.Cell width={2}><Checkbox label='NA' readOnly /></Table.Cell>
                            </Table.Row>
                        </Table.Body>
                    </Table>
                );
            case 'Other':
                return (
                    <Table celled>
                        <Table.Body>
                            <Table.Row key="0">
                                <Table.Cell>{question}</Table.Cell>
                                <Table.Cell width={2}><Checkbox label='De minimis' readOnly /></Table.Cell>
                                <Table.Cell width={2}><Checkbox label='Other' readOnly defaultChecked /></Table.Cell>
                                <Table.Cell width={2}><Checkbox label='NA' readOnly /></Table.Cell>
                            </Table.Row>
                        </Table.Body>
                    </Table>
                );
            default:
                return (
                    <Table celled>
                        <Table.Body>
                            <Table.Row key="0">
                                <Table.Cell>{question}</Table.Cell>
                                <Table.Cell width={2}><Checkbox label='De minimis' readOnly /></Table.Cell>
                                <Table.Cell width={2}><Checkbox label='Other' readOnly /></Table.Cell>
                                <Table.Cell width={2}><Checkbox label='NA' readOnly defaultChecked /></Table.Cell>
                            </Table.Row>
                        </Table.Body>
                    </Table>
                );
        }
    }

    renderStateAid = () => {
        try {
            const projectStateAid1Name = this.props.projectState.step2StateAid1;
            const capCallPartners = this.props.projectState.project.capCallPartners
            const newCapCallPartners = capCallPartners.filter(partner => partner.id === null);
            const projectStateAid1 = this.getChecklistByName(projectStateAid1Name);
            let stateAidComponents = [];
            let stateAid1components = projectStateAid1.detail.components ? projectStateAid1.detail.components : [];
            stateAid1components = stateAid1components.slice().sort((a, b) => a.position - b.position);
            stateAidComponents = stateAidComponents.concat(stateAid1components);
            let capCallPartnerList = [];


            capCallPartnerList = capCallPartners.filter(partner => partner.id !== null).map(partner => {
                return {
                    sortNumber: partner.sortNumber,
                    nameInEnglish: partner.identity.nameInEnglish,
                }
            });

            let newCapCallPartnerIndex = this.props.projectState.partners.length
            newCapCallPartners.forEach(partner => {
                newCapCallPartnerIndex++;
                capCallPartnerList.push({
                    sortNumber: newCapCallPartnerIndex,
                    nameInEnglish: partner.identity.nameInEnglish,
                });
            });


            const maxIndex = capCallPartnerList.sort((a, b) => b.sortNumber - a.sortNumber)[0].sortNumber;

            if (maxIndex > 12) {
                const projectStateAid2Name = this.props.projectState.step2StateAid2;
                const projectStateAid2 = this.getChecklistByName(projectStateAid2Name);
                if (!projectStateAid2) throw new Error('partnerNumberError');
                let stateAid2components = projectStateAid2.detail.components ? projectStateAid2.detail.components : [];
                stateAid2components = stateAid2components.slice().sort((a, b) => a.position < b.position ? -1 : 1);
                stateAidComponents = stateAidComponents.concat(stateAid2components)
            }

            let filteredComponents = [];
            let partnerNumber = 0;
            for (let i = 0; i < stateAidComponents.length; i++) {
                if (stateAidComponents[i + 1] && (stateAidComponents[i].type === 'HEADLINE' && stateAidComponents[i + 1].type === 'OPTIONS_TOGGLE') && partnerNumber < maxIndex) {
                    partnerNumber++;
                    let partnerName = capCallPartnerList.find(partner => partner.sortNumber === partnerNumber)?.nameInEnglish;
                    let component = {};
                    component.dataSelfCheck = {};
                    component.options = [];
                    component.partnerNumber = partnerNumber;
                    component.proposalGber = {};
                    component.proposal = {};
                    for (let j = 0; j < 6; j++) {
                        if (stateAidComponents[i + j].programmeMetadata.type === 'HEADLINE') {
                            component.title = stateAidComponents[i + j]
                            component.partnerName = partnerName;
                        } else if (stateAidComponents[i + j].programmeMetadata.type === 'OPTIONS_TOGGLE' && stateAidComponents[i + j].programmeMetadata.question === ' ') {
                            component.dataSelfCheck = stateAidComponents[i + j];
                        } else if (stateAidComponents[i + j].programmeMetadata.type === 'OPTIONS_TOGGLE') {
                            component.options.push(stateAidComponents[i + j]);
                        }
                    }
                    component.proposalGber = stateAidComponents[i + 6];
                    component.proposal = stateAidComponents[i + 7];
                    if (component.partnerName !== undefined) {
                        filteredComponents.push(component);
                    }
                }
            }

            console.warn("filteredComponents");
            console.warn(filteredComponents);

            const temp = filteredComponents.find((component) => !component.dataSelfCheck.instanceMetadata);
            if (temp) throw new Error('checklistNotFilled');

            return (
                <div>
                    <h3 className='sub-title'>{stateAidComponents[0].programmeMetadata.value}</h3>
                    <h4 className='little-margin'>{stateAidComponents[1].programmeMetadata.question}</h4>
                    <p className='little-margin'>{stateAidComponents[1].instanceMetadata.explanation}</p>
                    {stateAidComponents[2].instanceMetadata.answer === 'Yes' ?
                        <Segment.Group horizontal>
                            <Segment>{stateAidComponents[2].programmeMetadata.question}</Segment>
                            <Segment><Checkbox width={2} label='Yes' readOnly defaultChecked /></Segment>
                            <Segment><Checkbox width={2} label='No' readOnly /></Segment>
                        </Segment.Group>
                        :
                        <Segment.Group horizontal>
                            <Segment>{stateAidComponents[2].programmeMetadata.question}</Segment>
                            <Segment><Checkbox width={2} label='Yes' readOnly /></Segment>
                            <Segment><Checkbox width={2} label='No' readOnly defaultChecked /></Segment>
                        </Segment.Group>
                    }
                    {stateAidComponents[2].instanceMetadata.justification ? <p>{<Message content={stateAidComponents[2].instanceMetadata.justification} className='line-break' />}</p> : undefined}
                    {stateAidComponents[2].instanceMetadata.answer === 'Yes' ?
                        <h3 className='sub-title'>{stateAidComponents[3].programmeMetadata.value}</h3>
                        : undefined
                    }
                    {filteredComponents.map(item => {
                        return (
                            <div className='little-margin'>
                                {item.dataSelfCheck.instanceMetadata.answer === 'Yes' ?
                                    <div >
                                        <Table celled>
                                            <Table.Header className='table-header'>
                                                <Table.Row key="0">
                                                    <Table.Cell>{item.partnerName + ' - ' + item.title.programmeMetadata.value}</Table.Cell>
                                                    <Table.Cell width={2}><Checkbox label='Yes' readOnly defaultChecked /></Table.Cell>
                                                    <Table.Cell width={2}><Checkbox label='No' readOnly /></Table.Cell>
                                                </Table.Row>
                                            </Table.Header>
                                        </Table>
                                    </div>
                                    :
                                    <div>
                                        <Table celled>
                                            <Table.Header className='table-header'>
                                                <Table.Row key="0">
                                                    <Table.Cell>{item.partnerName + ' - ' + item.title.programmeMetadata.value}</Table.Cell>
                                                    <Table.Cell width={2}><Checkbox label='Yes' readOnly /></Table.Cell>
                                                    <Table.Cell width={2}><Checkbox label='No' readOnly defaultChecked /></Table.Cell>
                                                </Table.Row>
                                            </Table.Header>
                                        </Table>

                                        <Table celled>
                                            <Table.Header className='table-header'>
                                                <Table.Row key="0" style={this.headerStyle}>
                                                    <Table.Cell>Questions</Table.Cell>
                                                    <Table.Cell width={2}>Yes/No</Table.Cell>
                                                </Table.Row>
                                            </Table.Header>
                                            <Table.Body>
                                                {item.options.map(option => {
                                                    return (
                                                        <Table.Row key={option.id}>
                                                            <Table.Cell className='line-break'>{option.programmeMetadata.question} {option.instanceMetadata.justification ? <Message className='line-break' content={option.instanceMetadata.justification} /> : undefined}</Table.Cell>
                                                            <Table.Cell>{option.instanceMetadata.answer}</Table.Cell>
                                                        </Table.Row>
                                                    )
                                                })}
                                            </Table.Body>
                                        </Table>
                                        <div className='little-margin'>
                                            {this.renderGberProposal(item.proposalGber.instanceMetadata.answer, item.proposalGber.programmeMetadata.question)}
                                            {item.proposalGber.instanceMetadata.justification ? <p className='no-margin'>{<Message content={item.proposalGber.instanceMetadata.justification} />}</p> : undefined}
                                        </div>
                                        <div className='little-margin'>
                                            {this.renderProposal(item.proposal.instanceMetadata.answer,item.proposal.programmeMetadata.question)}
                                            {item.proposal.instanceMetadata.justification ? <p className='no-margin'>{<Message content={item.proposal.instanceMetadata.justification} />}</p> : undefined}
                                        </div>
                                    </div>
                                }
                            </div>
                        )
                    })}
                </div>
            );

        } catch (error) {
            switch (error.message) {
                case 'partnerNumberError':
                    return this.displayError(error, "There is more partners than permited by checklists", 'Please Check the State Aid checklists for this project');
                case 'checklistNotFilled':
                    return this.displayError(error, "It seems a checklist is still empty", 'Please Check the State Aid checklists for this project');
                default:
                    return <Message>There is no detailed State aid assessment available for this application, as it is not recommended for approval.</Message>;
            }
        }
    }

    render() {
        return (
            <div className='margin-report-1'>
                <table >
                    <thead>
                        <tr>
                            <th><Image src={logo} size='medium' /></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr className='page-break full-width'>
                            <td>
                                <h2 className='title'>Capitalisation initiative assessment report</h2>
                                <h3>Project identification</h3>
                                {this.renderProjectDescription()}
                                {this.renderProjectPriority()}
                                <h3>Project Budget</h3>
                                {this.renderProjectCosts()}
                                <h3>Implementation and spending profile</h3>
                                {this.renderImplementationAndSpendingProfile()}
                                <h3 >Summary of project</h3>
                                {this.renderProjectSummary()}

                            </td>
                        </tr>
                        <tr className='page-break full-width'>
                            <td>
                                <h3>Capitalisation Eligibility Checklist</h3>
                                {this.renderEligibilityChecklist()}
                            </td>
                        </tr>
                        <tr className='page-break full-width'>
                            <td>
                                <h3>Capitalisation Quality Assessment</h3>
                                {/* {this.renderQualityAssessmentSummary()} */}
                                {this.renderQualityAssessment()}
                                {this.renderQualityAssessmentOverallScore()}
                            </td>
                        </tr>
                        <tr className='page-break full-width'>
                            <td>
                                <h3>JS Opinion</h3>
                                {this.renderJSOpinion()}
                            </td>
                        </tr>
                        <tr className='page-break full-width'>
                            <td>
                                <h3>State Aid</h3>
                                {this.renderStateAid()}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        );
    }
}

export default ReportCapCall;